export const WEDDING_DATE_ISO = "2027-01-24T17:00:00+05:30";
export const HASHTAG = "#Viyush";

export const IMAGES = {
  hero: "/photos/couple-lake.jpg",
  lake: "/photos/couple-lake.jpg",
  haldi: "/photos/couple-haldi.jpg",
  piggyback: "/photos/couple-piggyback.jpg",
  canyon: "/photos/couple-canyon.jpg",
  sunselfie: "/photos/couple-sunselfie.jpg",
  ethnic: "/photos/couple-ethnic.jpg",
  heist: "/photos/couple-heist.jpg",
  diwali: "/photos/couple-diwali.jpg",
  grandcanyon: "/photos/couple-grandcanyon.jpg",
  graduation: "/photos/couple-graduation.jpg",
  ipl: "/photos/couple-ipl.jpg",
  decor: "https://images.unsplash.com/photo-1757017199822-beab923a1afc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYXJvb24lMjBnb2xkfGVufDB8fHx8MTc4OTU1MTU1MXww&ixlib=rb-4.1.0&q=85",
  mehendi: "https://images.pexels.com/photos/14825258/pexels-photo-14825258.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  resort: "/photos/leluxe.jpg",
  gallery3: "https://images.unsplash.com/photo-1599462616558-2b75fd26a283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwaW5kaWFuJTIwd2VkZGluZyUyMGNvdXBsZXxlbnwwfHx8fDE3ODk1NTE1NTF8MA&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1612945578381-6481cdd73b0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYXJvb24lMjBnb2xkfGVufDB8fHx8MTc4OTU1MTU1MXww&ixlib=rb-4.1.0&q=85",
};

export const VENUE_PHOTOS = [
  "/photos/leluxe.jpg",
  "/photos/leluxe-hall.jpg",
  "/photos/leluxe-stage.jpg",
  "/photos/leluxe-dj.jpg",
];

export const VENUE_MAP_EMBED = `https://maps.google.com/maps?q=${encodeURIComponent(
  "Faridabad-Gurgaon Rd, Baliyawas, Gwalpahari, Sector 2, Gurugram, Haryana 122003"
)}&z=14&output=embed`;

export const TRAVEL_TIMES = [
  {
    icon: "plane",
    label: "IGI Airport, New Delhi",
    time: "~50 min",
    note: "Approx. 30 km via NH-48 and Gurgaon-Faridabad Rd",
  },
  {
    icon: "car",
    label: "Cyber Hub, Central Gurgaon",
    time: "~35 min",
    note: "Approx. 20 km via Golf Course Extension Rd",
  },
  {
    icon: "metro",
    label: "Sikanderpur Metro (Yellow Line)",
    time: "~25 min",
    note: "Approx. 13 km - cabs easily available outside the station",
  },
  {
    icon: "train",
    label: "New Delhi Railway Station",
    time: "~1 hr 10 min",
    note: "Approx. 36 km - allow extra time on weekends",
  },
];

export const VENUE_NAME = "Lelux Resort, Gurgaon";
export const VENUE_COORDS = { lat: 28.4225, lng: 77.143 };

export const ORIGIN_CITIES = [
  { name: "Gurgaon / Delhi NCR", lat: 28.47, lng: 77.03 },
  { name: "Jaipur", lat: 26.91, lng: 75.79 },
  { name: "Agra", lat: 27.18, lng: 78.01 },
  { name: "Chandigarh", lat: 30.73, lng: 76.78 },
  { name: "Mumbai", lat: 19.08, lng: 72.88 },
  { name: "Bengaluru", lat: 12.97, lng: 77.59 },
  { name: "Kolkata", lat: 22.57, lng: 88.36 },
  { name: "Outside India", lat: 51.51, lng: -0.13 },
];
export const VENUE_ADDRESS =
  "Faridabad-Gurgaon Rd, Baliyawas, Gwalpahari, Sector 2, Gurugram, Haryana 122003";

export const mapsLink = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const EVENTS = [
  {
    key: "mehendi",
    number: "01",
    name: "Mehendi",
    date: "Friday, January 22",
    time: "Time to be announced",
    venue: "Venue to be announced",
    dress: "Shades of Green",
    blurb:
      "An intimate afternoon of henna, marigolds and old songs as the celebrations quietly begin.",
    image: IMAGES.mehendi,
  },
  {
    key: "engagement",
    number: "02",
    name: "Engagement",
    date: "Saturday, January 23",
    time: "5:00 PM onwards",
    venue: "Lelux Resort, Gurgaon",
    dress: "Evening Formals",
    blurb:
      "Rings are exchanged, promises are made, and two families officially become one. The Sangeet follows right after - no outfit change needed.",
  },
  {
    key: "sangeet",
    number: "03",
    name: "Sangeet & Cocktail",
    date: "Saturday, January 23",
    time: "9:00 PM onwards",
    venue: "Lelux Resort, Gurgaon",
    dress: "Same as Engagement, Add Sparkle",
    blurb:
      "Cocktails and dancing into the night - dance battles, dhol and performances. Bring your best moves; judgement-free zone.",
  },
  {
    key: "haldi",
    number: "04",
    name: "Haldi",
    date: "Sunday, January 24",
    time: "10:00 AM",
    venue: "Lelux Resort, Gurgaon",
    dress: "Yellows & Whites (Stain-Friendly)",
    blurb:
      "Turmeric, laughter and a little chaos. Wear something you won't mind turning gold.",
  },
  {
    key: "marriage",
    number: "05",
    name: "The Wedding",
    date: "Sunday, January 24",
    time: "5:00 PM onwards",
    venue: "Lelux Resort, Gurgaon",
    dress: "Traditional Indian Formal",
    blurb:
      "Under the winter sky, Vishi and Piyush take their vows. Dinner and dancing follow the pheras.",
    image: IMAGES.gallery3,
  },
];

export const STAYS_BY_BUDGET = [
  {
    key: "low",
    label: "Easy on the Pocket",
    range: "Under ₹5,000 / night",
    hotels: [
      {
        name: "Lemon Tree Hotel, Sohna Road",
        note: "Reliable chain comfort · approx. 15 min drive",
        query: "Lemon Tree Hotel Sohna Road Gurgaon",
      },
      {
        name: "FabHotel, Sushant Lok",
        note: "Simple, clean and central · approx. 15 min drive",
        query: "FabHotel Sushant Lok Gurgaon",
      },
    ],
  },
  {
    key: "medium",
    label: "Comfortable",
    range: "₹5,000 - ₹12,000 / night",
    hotels: [
      {
        name: "The Westin Sohna Resort & Spa",
        note: "Resort and spa, great for families · approx. 20 min drive",
        query: "The Westin Sohna Resort and Spa",
      },
      {
        name: "Courtyard by Marriott Aravali Resort",
        note: "Faridabad side, on the same highway · approx. 20 min drive",
        query: "Courtyard by Marriott Aravali Resort Faridabad",
      },
      {
        name: "Vivanta Surajkund",
        note: "Landscaped, calm, good food · approx. 20 min drive",
        query: "Vivanta Surajkund NCR",
      },
    ],
  },
  {
    key: "high",
    label: "Grand",
    range: "₹12,000+ / night",
    hotels: [
      {
        name: "ITC Grand Bharat",
        note: "Palatial Aravalli retreat · approx. 25 min - worth the extra five",
        query: "ITC Grand Bharat Manesar Gurgaon",
      },
      {
        name: "Taj Damdama Lake Resort & Spa",
        note: "Lakeside luxury under the hills · approx. 25 min drive",
        query: "Taj Damdama Lake Resort and Spa",
      },
    ],
  },
];

export const THINGS_TO_DO = [
  {
    key: "shopping",
    label: "Shopping",
    items: [
      { name: "Ambience Mall, Gurgaon", note: "Everything under one roof · ~30 min" },
      { name: "Dilli Haat, INA", note: "Handicrafts and street food from every state - a first-timer favourite · ~45 min" },
      { name: "Khan Market, Delhi", note: "Boutiques, bookshops and cafés · ~50 min" },
    ],
  },
  {
    key: "sightseeing",
    label: "Sightseeing",
    items: [
      { name: "Qutub Minar", note: "The closest wonder to the venue - go near sunset · ~30 min" },
      { name: "Humayun's Tomb", note: "The Taj's quieter, lovelier ancestor · ~50 min" },
      { name: "India Gate & Kartavya Path", note: "The classic Delhi evening stroll · ~55 min" },
      { name: "Red Fort & Chandni Chowk", note: "Old Delhi in full colour - go hungry · ~1 hr" },
    ],
  },
  {
    key: "chilling",
    label: "Chilling",
    items: [
      { name: "Damdama Lake", note: "Boating and Aravalli views · ~20 min" },
      { name: "32nd Avenue", note: "Cafés, live music and pretty lights · ~30 min" },
      { name: "Cyber Hub", note: "The city's dinner-and-drinks district · ~35 min" },
      { name: "Sultanpur Bird Sanctuary", note: "Quiet winter-morning birdwatching · ~30 min" },
    ],
  },
];

export const COUPLE_NOTE = {
  title: "A Note From Us",
  lines: [
    "These three days mean the world to us, and having you there is the real celebration. Come as you are; leave as family.",
  ],
  signoff: "Vishi & Piyush",
};
